import { FC } from 'react';
import { TVoyageSummary } from '../../mapTypes';

export interface IVoyageHoverPopupContentProps {
	info: TVoyageSummary;
}

const VoyageHoverPopupContent: FC<IVoyageHoverPopupContentProps> = ({ ...props }) => {
	return (
		<div className="flex flex-col gap-2">
			<div>
				<span className="font-bold">Origin : </span>
				<span>{props?.info?.originName?.toUpperCase()}</span>
			</div>
			<div>
				<span className="font-bold">Departure : </span>
				<span>{props?.info?.originEndTime! && new Date(props?.info?.originEndTime).toLocaleString()}</span>
			</div>
			<div>
				<span className="font-bold">Destination : </span>
				<span>{props?.info?.destinationName?.toUpperCase()}</span>
			</div>
			<div>
				<span className="font-bold">Arrival : </span>
				<span>{props?.info?.destinationStartTime && new Date(props?.info?.destinationStartTime).toLocaleString()}</span>
			</div>
		</div>
	);
};

export default VoyageHoverPopupContent;
